@let methodology = bulkFunctionalUsagePlugin.selectors.methodology.asSignal();
@let serviceCenterId =
  bulkFunctionalUsagePlugin.selectors.serviceCenterId.asSignal();
@let functionalizations =
  bulkFunctionalUsagePlugin.selectors.functionalizations.asSignal();
@let error = bulkFunctionalUsagePlugin.selectors.error.asSignal();
@let isSubmitting = bulkFunctionalUsagePlugin.selectors.isSubmitting.asSignal();

<atn-ds-centered-overlay type="wide">
  <div class="atn-space-bulk-functional-usage-modal">
    <atn-ds-widget [title]="titleSg()">
      <div actions>
        <i
          class="atn-icon atn-close atn-red"
          (click)="cancelClickHandler()"
        ></i>
      </div>

      <div class="atn-space-bulk-functional-usage-modal__content">
        <div class="atn-space-bulk-functional-usage-modal__field">
          <span><b>Methodology</b></span>
          <atn-ds-select-single
            [items]="methodologyItemsSg()"
            [value]="methodology"
            [required]="true"
            (valueChange)="updateFunctionalizationMethodology($event)"
          />
        </div>

        @if (isManualMethodologySg()) {
          <div class="atn-space-bulk-functional-usage-modal__field">
            <span><b>Allocations</b></span>
            <atn-space-modal-functionalizations
              [functionalizations]="functionalizations"
              (functionalizationChange)="updateFunctionalization($event)"
            />
          </div>
        }

        @if (isServiceCenterMethodologySg()) {
          <div class="atn-space-bulk-functional-usage-modal__field">
            <span><b>Service Center</b></span>
            <atn-ds-select-single
              [items]="serviceCenterItemsSg()"
              [value]="serviceCenterId"
              [required]="true"
              (valueChange)="updateServiceCenterHandler($event)"
            />
          </div>

          <div class="atn-space-bulk-functional-usage-modal__field">
            <span><b>Allocations</b></span>
            <atn-space-modal-functionalizations
              [functionalizations]="serviceCenterFunctionalizationsSg()"
              [readonly]="true"
            />
          </div>
        }

        @if (isJointUseMethodologySg()) {
          @let jointUsePlugin = jointUsePluginSg();

          <div
            class="atn-space-bulk-functional-usage-modal__field atn-space-bulk-functional-usage-modal__field--full-height"
          >
            <span><b>Allocations</b></span>
            @if (hasRecordWithoutOccupierSg()) {
              <atn-ds-notice
                description="Space Record must have assigned Occupier Organization to use Joint Use methodology."
                [style]="DisplayStyle.Warning"
              />
            } @else if (sharedOccupierIdSg()) {
              <atn-space-modal-functionalizations
                [functionalizations]="
                  jointUsePlugin?.feature?.selectors?.functionalizations?.asSignal() ??
                  []
                "
                [loading]="
                  jointUsePlugin?.feature?.selectors?.isLoading?.asSignal() ??
                  false
                "
                [readonly]="true"
              />
            } @else {
              <atn-ds-notice
                description="Cannot preview calculated functional usage, since Space Records are assigned to different Organizations."
                [style]="DisplayStyle.Info"
              />
            }
          </div>
        }

        @if (error) {
          <atn-ds-notice
            [style]="DisplayStyle.Error"
            [description]="error.message"
          />
        }
      </div>

      <div
        class="atn-space-bulk-functional-usage-modal__footer"
        footer
      >
        <atn-ds-button
          type="transparent"
          (click)="cancelClickHandler()"
          >Cancel</atn-ds-button
        >
        <atn-ds-button
          [disabled]="!canConfirmSg()"
          [loading]="isSubmitting"
          (click)="saveClickHandler()"
          >Save</atn-ds-button
        >
      </div>
    </atn-ds-widget>
  </div>
</atn-ds-centered-overlay>
